import { CHATROOM_INPUT_INSERT_REPLACE_OPTION_VALUE } from '../Chatroom.constants'

export function getChatroomInputTemplateConfirmationOptions({ t }) {
  return [
    {
      id: CHATROOM_INPUT_INSERT_REPLACE_OPTION_VALUE.Insert,
      label: t('Chatroom.TemplateConfirmationInsertOptionKey'),
    },
    {
      id: CHATROOM_INPUT_INSERT_REPLACE_OPTION_VALUE.Replace,
      label: t('Chatroom.TemplateConfirmationReplaceOptionKey'),
    },
  ]
}
